import localstorage from './localstorage'
export default (Vue: any, next: any, modules: string, role: string, validation: boolean = true) => {
    return async () => {
        const userrole = localstorage.getItem('role')
        if (userrole == 'Superadmin' || userrole == 'Customer-Care' || userrole == 'GodMode') {
            return Promise.resolve()
        }
        const privilages = Vue.store.state.HOMEPAGE.privilages

        if (privilages[modules] && privilages[modules].suspend) {
            Vue.store.commit('DASHBOARD/setopendialogdonthavepermission', 'suspend')
            return Promise.reject()
        }

        // Jika user adalah creator organisasi, izinkan akses tanpa cek privilage per role.
        // Ref: https://agile.cloudeka.ai/project/service-portal-devops/task/535
        const isCreator = localstorage.getItem('is_creator') == 'true'
        if (isCreator) {
            return Promise.resolve()
        }

        if (privilages[modules] && privilages[modules][role] == validation) {
            return Promise.resolve()
        } else {
            Vue.store.commit('DASHBOARD/setopendialogdonthavepermission', true)
            return Promise.reject()
        }
    }
}